import { FlexBox } from '@ardoq/layout';
import { PageWrapper } from '@ardoq/page-layout';
import { Tab, TabList } from '@ardoq/tabs';
import {
  MOVE_TO_GLOBAL_DROP_ZONE_SELECTOR,
  WorkspaceDocumentArchivePageViewProps,
} from '../../workspaceManager/pages/documentArchive/WorkspaceDocumentArchivePageView';
import {
  DeleteConfirmationModal,
  DocumentArchiveViewProps,
  DocumentArchiveTableView,
  DropZone,
  MoveToModal,
} from '../DocumentArchivePageView';
import { TabId } from './types';

export type DocumentArchiveFilePickerPageViewProps =
  | DocumentArchiveGlobalFilePickerPageViewProps
  | DocumentArchiveWorkspaceFilePickerPageViewProps;

export type TabsProps = {
  items: {
    id: TabId;
    label: string;
  }[];
  selectedId: TabId;
  onChange: (tabId: TabId) => void;
  moreButtonLabel: string;
};

export const DocumentArchiveFilePickerPageView = (
  props: DocumentArchiveFilePickerPageViewProps
) => (
  <>
    <PageWrapper>
      {props.tabs && (
        <TabList
          activeTabId={props.tabs.selectedId}
          onTabChange={props.tabs.onChange}
          moreButtonLabel={props.tabs.moreButtonLabel}
        >
          {props.tabs.items.map(tab => (
            <Tab
              key={tab.id}
              tabId={tab.id}
              label={tab.label}
              title={tab.label}
            />
          ))}
        </TabList>
      )}
      <FlexBox
        flexDirection="column"
        paddingX="large"
        paddingY="small"
        overflowY="auto"
      >
        {props.type === 'global' ? (
          <DocumentArchiveGlobalFilePickerPageView {...props} />
        ) : (
          <DocumentArchiveWorkspaceFilePickerPageView {...props} />
        )}
      </FlexBox>
    </PageWrapper>
    <DeleteConfirmationModal {...props.deleteConfirmationModal} />
    <MoveToModal {...props.moveToModal} />
  </>
);

type SharedProps = {
  title: string;
  tabs: TabsProps | null;
};

export type DocumentArchiveGlobalFilePickerPageViewProps = SharedProps &
  DocumentArchiveViewProps & {
    type: 'global';
  };

const DocumentArchiveGlobalFilePickerPageView = (
  props: DocumentArchiveGlobalFilePickerPageViewProps
) => (
  <>
    <DropZone {...props.dropZone} />
    <DocumentArchiveTableView {...props.table} />
  </>
);

export type DocumentArchiveWorkspaceFilePickerPageViewProps = SharedProps &
  WorkspaceDocumentArchivePageViewProps & {
    type: 'workspace';
  };

const DocumentArchiveWorkspaceFilePickerPageView = (
  props: DocumentArchiveWorkspaceFilePickerPageViewProps
) => (
  <>
    <FlexBox width="full" id={MOVE_TO_GLOBAL_DROP_ZONE_SELECTOR}>
      <DropZone {...props.dropZone} />
    </FlexBox>
    <DocumentArchiveTableView {...props.table} />
  </>
);
